import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const undergroundWalkTimeDefinition = definitionFactory({
  key: 'underground_walk_time',
  mapper: ({ lte }) =>
    lte
      ? [
          {
            label: `Пешком до метро не больше ${lte} мин.`,
            value: { lte },
          },
        ]
      : [],
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'underground_walk_time', options);
  },
});
